/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_DescriptionInputs */

const en_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and manage commit history snapshots`)
};

const fr_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher et gerer l'historique des commits`)
};

const de_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit-Verlauf-Snapshots anzeigen und verwalten`)
};

const it_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza e gestisci gli snapshot della cronologia degli impegni`)
};

const ru_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр и управление снимками истории коммитов.`)
};

const es_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver y administrar instantáneas del historial de confirmaciones`)
};

const zh_cn2_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看和管理提交历史快照`)
};

const ja_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミット履歴のスナップショットを表示および管理する`)
};

const hi_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कमिट हिस्ट्री स्नैपशॉट देखें और प्रबंधित करें`)
};

const pt_pt2_snapshot_history_description = /** @type {(inputs: Snapshot_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualize e gerencie snapshots do histórico de commits.`)
};

/**
* | output |
* | --- |
* | "View and manage commit history snapshots" |
*
* @param {Snapshot_History_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_description = /** @type {((inputs?: Snapshot_History_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_description(inputs)
	if (locale === "de") return de_snapshot_history_description(inputs)
	if (locale === "it") return it_snapshot_history_description(inputs)
	if (locale === "ru") return ru_snapshot_history_description(inputs)
	if (locale === "es") return es_snapshot_history_description(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_description(inputs)
	if (locale === "ja") return ja_snapshot_history_description(inputs)
	if (locale === "hi") return hi_snapshot_history_description(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_description(inputs)
	return en_snapshot_history_description(inputs)
});